const CATEGORIES = require('./nationalAccessibility');

/**
 * @typedef Citizenship
 * @property {'ru'} RU Россия
 * @property {'nr'} NR Новые регионы
 * @property {'am'} AM Армения
 * @property {'by'} BY Беларусь
 * @property {'kz'} KZ Казахстан
 * @property {'kg'} KG Кыргызстан
 * @property {'other'} OTHER Другое
 */

/** @type {Readonly<Citizenship>} */
const CITIZENSHIP = {
  RU: 'ru',
  NR: 'nr',
  AM: 'am',
  BY: 'by',
  KZ: 'kz',
  KG: 'kg',
  OTHER: 'other',
};

/** @type {Record<NationalAccessibility, Citizenship[]>} */
const CITIZENSHIP_CATEGORY = {
  [CATEGORIES.RUS]: [CITIZENSHIP.RU, CITIZENSHIP.NR],
  [CATEGORIES.OTHER]: [CITIZENSHIP.OTHER],
  [CATEGORIES.EAEU]: [
    CITIZENSHIP.AM,
    CITIZENSHIP.BY,
    CITIZENSHIP.KZ,
    CITIZENSHIP.KG,
  ],
};

module.exports = {
  CITIZENSHIP,
  CITIZENSHIP_CATEGORY,
};
